import { useMemo } from 'react';

import { useTheme } from '@emotion/react';
import { Stack, TextareaAutosize, Typography } from '@mui/material';
import { Field } from 'formik';

interface NPITextareaFieldProps {
    isDisabled?: boolean;
    fieldName?: string;
    placeholder?: string;
    defaultValue?: string | number;
    minRows?: number;
    characterLimit?: number;
    error?: string;
}

function NPITextareaField({
    isDisabled,
    fieldName,
    placeholder,
    defaultValue,
    minRows = 4,
    error,
    characterLimit,
}: NPITextareaFieldProps) {
    const theme = useTheme();
    const textAreaStyle = useMemo(() => {
        return {
            borderRadius: '8px',
            padding: '10px',
            border: `1px solid ${theme.palette.orange.main}`,
        };
    }, [theme.palette.orange.main]);

    return (
        <Stack width="100%">
            <Field name={fieldName}>
                {({ field }) => {
                    return (
                        <Stack width="100%" flexDirection="column">
                            <TextareaAutosize
                                {...field}
                                minRows={minRows}
                                defaultValue={defaultValue}
                                autoComplete="off"
                                disabled={isDisabled}
                                placeholder={placeholder}
                                style={textAreaStyle}
                                {...(characterLimit ? { maxLength: characterLimit } : {})}
                            />
                            {error ? (
                                <Typography color={theme.palette.error.main}>{error}</Typography>
                            ) : null}
                            {characterLimit && field.value.length > 0 ? (
                                <Typography
                                    color={`${
                                        characterLimit === field.value.length
                                            ? theme.palette.error.main
                                            : ''
                                    }`}
                                >
                                    {characterLimit === field.value.length
                                        ? `${characterLimit} character limit reached`
                                        : `${characterLimit - field.value.length} characters left`}
                                </Typography>
                            ) : null}
                        </Stack>
                    );
                }}
            </Field>
        </Stack>
    );
}

export default NPITextareaField;
